import React from 'react'
import Banner from '../components/Banner/Banner'
import Coinstable from '../components/coinstable'

const homepage = () => {
  return (
   <>
    <Banner />
    <Coinstable />
   </>
  )
}

export default homepage
